import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Chat, ChatBase, ChatMessage } from '@aimi/models';
import { environment } from '../../../environments/environment';

interface CreateChatResponse extends Chat {
  messages: ChatMessage[];
}

@Injectable({
  providedIn: 'root',
})
export class ChatService {
  #http = inject(HttpClient);

  createChat(data: { message: string }) {
    return this.#http.post<CreateChatResponse>(
      `${environment.apiUrl}/chats`,
      data,
    );
  }

  createChatMessage(chatId: string, data: { message: string }) {
    return this.#http.post<ChatMessage>(
      `${environment.apiUrl}/chats/${chatId}/messages`,
      data,
    );
  }

  getChatMessages(data: { chatId: string }) {
    return this.#http.get<ChatMessage[]>(
      `${environment.apiUrl}/chats/${data.chatId}/messages`,
    );
  }

  getChats() {
    return this.#http.get<ChatBase[]>(`${environment.apiUrl}/chats`);
  }

  deleteChat(chatId: string) {
    return this.#http.delete<void>(`${environment.apiUrl}/chats/${chatId}`);
  }
}
